"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_AUTO_TRACK_EVENT_TYPE = exports.IDENTIFY_EVENT_TYPE = exports.PERSONALIZE_FLUSH_SIZE_MAX = exports.DEFAULT_PERSONALIZE_CONFIG = void 0;
exports.DEFAULT_PERSONALIZE_CONFIG = {
    flushSize: 5,
    flushInterval: 5000,
};
exports.PERSONALIZE_FLUSH_SIZE_MAX = 10;
exports.IDENTIFY_EVENT_TYPE = 'Identify';
exports.MEDIA_AUTO_TRACK_EVENT_TYPE = 'MediaAutoTrack';
